(function (global) {
  'use strict';

  var ICON_RULES = [
    { re: /concrete dust|dust control|debris|particulate/, icon: 'tcb-menu-icon-air-filter.svg' },
    { re: /forklift|traffic lane/, icon: 'tcb-menu-icon-warehouse.svg' },
    { re: /loading dock|dock soil/, icon: 'tcb-menu-icon-delivery-truck.svg' },
    { re: /square footage|large area|large space|multi-building/, icon: 'tcb-menu-icon-industrial-building.svg' },
    { re: /spill|wet floor/, icon: 'tcb-menu-icon-water-damage.svg' },
    { re: /carpet|spot|stain|extraction/, icon: 'tcb-menu-icon-floor-pad.svg' },
    { re: /odor|smell/, icon: 'tcb-menu-icon-spray-bottle.svg' },
    { re: /restroom|sanitation|toilet/, icon: 'tcb-menu-icon-toilet-cleaner.svg' },
    { re: /grease|degreas|kitchen|cafeteria/, icon: 'tcb-menu-icon-industrial-spray.svg' },
    { re: /floor scrub|scrubber|floor shine|hard floor|lobby floor|rubber floor|gym floor/, icon: 'tcb-menu-icon-walk-behind-scrubber.svg' },
    { re: /extractor|carpet clean/, icon: 'tcb-menu-icon-box-extractor.svg' },
    { re: /vacuum|sweeper/, icon: 'tcb-menu-icon-upright-vacuum.svg' },
    { re: /turnover|housekeeping|efficiency|after-hours speed|speed/, icon: 'tcb-menu-icon-shop-cart.svg' },
    { re: /guest|presentation|appearance|lobby appearance/, icon: 'tcb-menu-icon-quality-shield.svg' },
    { re: /gym|weight room|cardio|rubber/, icon: 'tcb-menu-icon-scrub-brush.svg' },
    { re: /school|classroom|hallway|after-event|event cleanup/, icon: 'tcb-menu-icon-school.svg' },
    { re: /hotel|guest room/, icon: 'tcb-menu-icon-hotel.svg' },
    { re: /health|clinic|patient|waiting room/, icon: 'tcb-menu-icon-hospital.svg' },
    { re: /safety|ppe|disinfect|touchpoint|trash/, icon: 'tcb-menu-icon-hand-sanitizer.svg' },
    { re: /part|maintenance|filter|blade|storage/, icon: 'tcb-menu-icon-gear-part.svg' },
    { re: /budget|volunteer|startup|solo/, icon: 'tcb-menu-icon-calculator.svg' },
    { re: /property|move-in|move-out|leasing|apartment/, icon: 'tcb-menu-icon-industrial-building.svg' },
    { re: /contractor|route|multi-surface|van/, icon: 'tcb-menu-icon-shop-cart.svg' },
    { re: /quiet|office|corporate|janitorial/, icon: 'tcb-menu-icon-industrial-building.svg' },
    { re: /sanctuary|fellowship|church/, icon: 'tcb-menu-icon-guide-book.svg' },
    { re: /buffer|burnish|strip/, icon: 'tcb-menu-icon-floor-buffer.svg' },
    { re: /chemical|supply/, icon: 'tcb-menu-icon-chemical-jug.svg' },
  ];

  function esc(v) {
    return String(v || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function assetBaseFromSample(sampleUrl) {
    if (!sampleUrl) return '';
    var idx = sampleUrl.lastIndexOf('/');
    return idx >= 0 ? sampleUrl.slice(0, idx + 1) : '';
  }

  function iconFileForTitle(title) {
    var t = String(title || '').toLowerCase();
    for (var i = 0; i < ICON_RULES.length; i++) {
      if (ICON_RULES[i].re.test(t)) return ICON_RULES[i].icon;
    }
    return 'tcb-menu-icon-recommendation.svg';
  }

  function normalizePainPoints(items) {
    return (items || []).map(function (p) {
      return { title: p.title, text: p.text || p.body || '' };
    }).filter(function (p) { return p.title; });
  }

  function renderCard(point, assetBase) {
    var iconUrl = assetBase + iconFileForTitle(point.title);
    return (
      '<li class="tcb-pain-challenges__card">' +
        '<span class="tcb-pain-challenges__icon" aria-hidden="true">' +
          '<img src="' + esc(iconUrl) + '" alt="' + esc(point.title) + ' challenge icon" width="40" height="40" loading="lazy" decoding="async" aria-hidden="true">' +
        '</span>' +
        '<strong>' + esc(point.title) + '</strong>' +
        '<span>' + esc(point.text) + '</span>' +
      '</li>'
    );
  }

  function render(options) {
    var zone = options.zone;
    var grid = options.grid;
    var headingEl = options.headingEl;
    var painPoints = normalizePainPoints(options.painPoints);
    var heading = options.heading;
    var assetBase = assetBaseFromSample(options.assetSample);

    if (!grid || !painPoints.length) {
      if (zone) zone.hidden = true;
      return false;
    }

    if (headingEl && heading) headingEl.textContent = heading;
    grid.innerHTML = painPoints.map(function (p) {
      return renderCard(p, assetBase);
    }).join('');
    if (zone) zone.hidden = false;
    return true;
  }

  global.TcbPainChallenges = {
    render: render,
    iconFileForTitle: iconFileForTitle,
    normalizePainPoints: normalizePainPoints,
  };
})(window);
